const constHistory = {
    NB_ELEMENT_HISTORIC_ADDRESS : 5,
}

export default constHistory;